<template>
  <div class="w100 sift-box">
    <!-- <div class="pl5 pr5 mb10" :style="compWidth()" v-for="(item, index) in siftData" :key="index"> -->
    <component ref="siftComp" v-for="(item, index) in siftData" :key="index" :is="compSiftName(item.type)" :colspan="colspan" :type-data="item" :width="width" @handle-search="handleSearch"></component>
    <!-- </div> -->
    <slot></slot>
  </div>
</template>

<script>
import TextComp from "@/components/sift/TextComp";
import SelectComp from "@/components/sift/SelectComp";
import SelectsComp from "@/components/sift/SelectsComp";
import DateComp from "@/components/sift/DateComp";
import TimeComp from "@/components/sift/TimeComp";
import DateTimeComp from "@/components/sift/DateTimeComp";
import BEDateComp from "@/components/sift/BEDateComp";
import RadioComp from "@/components/sift/RadioComp";
import CascaderComp from "@/components/sift/CascaderComp";
import AutocompleteComp from "@/components/sift/AutocompleteComp";

export default {
  name: "sift-comp",
  props: ["sift-data", "searching", "colspan"],
  components: {
    TextComp,
    SelectComp,
    SelectsComp,
    DateComp,
    TimeComp,
    DateTimeComp,
    BEDateComp,
    RadioComp,
    AutocompleteComp,
  },
  data() {
    return {
      width: "auto",
    };
  },
  created() {
    const arr = this.siftData.map((val) => val.label.length);
    this.width = Math.max(...arr) + 1;
    // console.log(this.width);
  },
  computed: {},
  mounted() {},
  methods: {
    getSiftValue(needSelectsStr) {
      var obj = {};
      // console.log(this.siftData);
      for (const i in this.siftData) {
        if (this.siftData[i].type == "tree") continue;

        // console.log(this.siftData[i].key);
        if (this.siftData[i].type == "bedate") {
          const arr = this.siftData[i].key.split(",");
          if (this.$refs.siftComp[i].value) {
            obj[arr[0]] = this.$refs.siftComp[i].value[0];
            obj[arr[1]] = this.$refs.siftComp[i].value[1];
          } else {
            obj[arr[0]] = "";
            obj[arr[1]] = "";
          }
        } else if (this.siftData[i].type == "cascader") {
          const arr = this.$refs.siftComp[i].getValue();
          for (const item of arr) {
            const name = item.key;
            obj[name] = item.value;
          }
        } else if (this.siftData[i].type == "selects" && needSelectsStr) {
          const name = this.siftData[i].key;
          if (this.$refs.siftComp[i].value.indexOf("") > -1) {
            obj[name] = "";
          } else {
            obj[name] = this.$refs.siftComp[i].value.join(",");
          }
        } else {
          obj[this.siftData[i].key] = this.$refs.siftComp[i].value;
        }
      }
      return obj;
    },
    compSiftName(value) {
      switch (value) {
        case "text":
          return TextComp;
        case "select":
          return SelectComp;
        case "selects":
          return SelectsComp;
        case "date":
          return DateComp;
        case "time":
          return TimeComp;
        case "datetime":
          return DateTimeComp;
        case "bedate":
          return BEDateComp;
        case "radio":
          return RadioComp;
        case "cascader":
          return CascaderComp;
        case "autocomplete":
          return AutocompleteComp;
        default:
          // return TextComp;
          break;
      }
    },
    compWidth() {
      if (this.colspan) {
        if (typeof this.colspan == "number") {
          return { width: this.colspan + "px" };
        } else {
          return { width: this.colspan };
        }
      } else {
        return { width: "33%" };
      }
    },
    handleSearch() {
      this.$emit("handle-search");
    },
  },
};
</script>

<style scoped>
.sift-box {
  display: flex;
  flex-wrap: wrap;
}
</style>
